import { render } from "./Seguridad.vue?vue&type=template&id=6e165776&scoped=true"
import script from "./Seguridad.vue?vue&type=script&lang=js"
export * from "./Seguridad.vue?vue&type=script&lang=js"

import "./Seguridad.vue?vue&type=style&index=0&id=6e165776&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e165776"]])

export default __exports__